@if ({
  row: columnData | async,
  adata: additionData | async
  }; as $) {
  <div class="flex align-items-center">
    <div class="w-4rem">
      @if ($.row && $.row.refund_isvoid ) {
        <p-tag severity="warning" styleClass="text-xxs font-normal uppercase white-space-nowrap" >Void</p-tag>
      } @else {
        @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'initiated'  || $.row[$.adata.fetch_key] === '1' )) {
          <p-tag severity="success"
          styleClass="text-xxs font-normal uppercase white-space-nowrap">Initiated</p-tag>
        }
        @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'refunded' || $.row[$.adata.fetch_key] === '2' )) {
          <p-tag severity="warning"
          styleClass="text-xxs font-normal uppercase white-space-nowrap">Refunded</p-tag>
        }
        @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'failed' || $.row[$.adata.fetch_key] === '3' )) {
          <p-tag severity="danger"
          styleClass="text-xxs font-normal uppercase white-space-nowrap">Failed</p-tag>
        }
      }
    </div>
  </div>
}